import React from "react";
import SoilTriangle, { SoilTriangleProps } from "./SoilTriangle";
import cropr from "../utils/cropr";
import { findInObjectByKey, getProp } from "../utils/javascript";

interface SoilTriangleCroprCodesProps extends Omit<SoilTriangleProps, "selected" | "onChange"> {
  selected: number;
  onChange?: (soilcode: number | null) => void;
}

const SoilTriangleCroprCodes = ({ onChange, selected, ...props }: SoilTriangleCroprCodesProps) => (
  <SoilTriangle
    selected={(cropr.soiltype[selected] || {}).edi_code}
    onChange={(e) => {
      onChange?.(
        e?.ediCode && getProp(findInObjectByKey(cropr.soiltype, "edi_code", e.ediCode), "id")
      );
    }}
    {...props}
  />
);

export default SoilTriangleCroprCodes;
